<template>
  <div>
    <div class="modalcontainer pb-4" :class="{ 'view-mode': !editMode }">
      <!-- edit node starts  -->
      <div class="pb-3" v-if="shape === 'node-rect'|| shape === 'qc-rect'">
        <div
          class="condition-builder-entry"
          v-if="(shape === 'node-rect' || shape === 'qc-rect') && isFirstStep && isLifecycleCategory"
        >
          <button
            type="button"
            class="condition-settings-btn"
            @click="$emit('open-condition-builder')"
            v-tooltip="'Add Conditions'"
          >
            <img src="~@/assets/images/settings.svg" alt="Condition Builder" width="18">
          </button>
        </div>
        <div class="input-group imp mt-1" data-validation="step_name">
          <label class="key">{{ editMode ? 'Enter the name' : 'Name' }}</label>
          <input
            type="text"
            v-model="editData.newLabel"
            :placeholder="editMode ? 'Enter the new name' : ''"
            maxlength="50"
            :disabled="!editMode"
          />
        </div>
        <div class="input-group imp mt-1" data-validation="step_department" >
          <label class="key">{{ editMode ? 'Select the Department' : 'Department' }}</label>
          <div class="v-center gap-1" :class="{ 'dropdown-disabled': !editMode }">
              <custom-dropdown
                  :list="userGroups"
                  :selected="{id:editData.userGroup}"
                  :dataValidation="'step_department'"
                  :enableSearch="true"
                  :disabled="!editMode"
                  @select="userGroupchange"
                  @deselect="refershEditData('userGroup')"
                  class="form-template-container-wft flex-grow"
                />
                  <!-- <img
                  v-if="showremoveUserGroup"
                  src="~@/assets/images/delete-icon.svg"
                  width="18"
                  alt="delete icon"
                  class="pointer"
                  @click="removeUserGroup"
                /> -->
                </div>
        </div>
        <div class="gap-1">
          <div class="input-group imp mt-1" data-validation="step_duration">
            <label class="key">Duration</label>
            <div class='grid-2 gap-1' :class="{ 'dropdown-disabled': !editMode }">
              <input
              type="number"
              min="0"
              v-model.number="editData.duration"
              :placeholder="editMode ? 'Enter the duration' : ''"
              @keypress="blockMinus"
              :disabled="!editMode"
            />
            <!-- <select
              v-model="editData.durationType"
            >
            <option :selected="editData.durationType === 1" value="1">Days</option>
              <option :selected="(editData.durationType === 2 || !editData.durationType)" value="2">Hours</option>
              <option :selected="editData.durationType === 3" value="3">Minutes</option>
            </select> -->

                  <custom-dropdown
                  :list="[{ id: 1, name: 'Days' }, { id: 2, name: 'Hours' }, { id: 3, name: 'Minutes' }]"
                  :selected="{id:editData.durationType}"
                  @select="(item)=>editData ={...editData, durationType: item.id}"
                  @deselect="() => {}"
                  class="form-template-container-wft flex-grow"
                />
          </div>
          </div>
          <div class="input-group mt-1" data-validation="step_escaltion">
            <label class="key v-center">Escalation threshold <span class="weight-400  s"> (In days)</span> </label>
            <div class="v-center gap-1">
            <input
              type="number"
              min="0"
              v-model.number="editData.escalation"
              :placeholder="editMode ? 'Enter the escalation threshold' : ''"
              @keypress="blockMinus"
              :disabled="!editMode"
            />
            </div>
          </div>
        </div>
          <div class="my-2 input-group imp" v-if="shape === 'qc-rect'"  dataValidation="step_checklist_template" >
              <label>{{ editMode ? 'Select checklist Template' : 'Checklist Template' }}</label>
              <div class="flex v-center gap-1" :class="{ 'dropdown-disabled': !editMode }">
                <custom-dropdown
                  :list="qcFormTempaltesFiltered"
                  :selected="editData.qcFormTempalate"
                  :dataValidation="'step_checklist_template'"
                  @select="hadleQcFormTempalate"
                  @toggle="formSearchKeyword = ''"
                  @deselect="refershEditData('qcFormTempalate')"
                  class="form-template-container-wft flex-grow"
                >
                  <template #before-items>
                    <div
                      class="fh input-group center p-3 form-template-container-wft-search-box"
                    >
                      <input
                        type="text p-2"
                        class="form-template-container-wft-input"
                        v-model="formSearchKeyword"
                        placeholder="Search"
                      />
                    </div>
                    <div
                      class="fh center py-4"
                      v-if="formTempaltesFiltered.length === 0"
                    >
                      No forms templates
                    </div>
                  </template>
                </custom-dropdown>
              </div>
            </div>
  <!--  workflow  outsource/insource start  -->
                <div class=" input-group v-center gap-1 grow-1 mt-2" v-if="processPlanFeature  && !editData.qcParentStepId">
                <label class="sourceSelect"> {{ editMode ? 'Select source:' : 'Source:' }} </label>
                <div class="toggle-btn" :class="{ 'dropdown-disabled': !editMode }">
                  <button
                    :class="[
                      'toggle-option',
                      { active: !outSourceToggle },
                    ]"
                    @click="setOutsource(false)"
                  >
                    In House
                  </button>
                  <button
                    :class="[
                      'toggle-option',
                      { active: outSourceToggle },
                    ]"
                    @click="setOutsource(true)"                  >
                    Outsourced
                  </button>
                </div>
                </div>

             <div class="input-group mt-1 " :class="{ 'dropdown-disabled': !editMode }"  data-validation="step_resource_machine" v-if="!outSourceToggle && processPlanFeature && !editData.qcParentStepId">
            <label class="key v-center ">{{ editMode ? 'Select Machines' : 'Machines' }}<span class="required-asterisk">*</span></label>
              <MultiSelectDropdown
                :options="resourceList.filter(r => r.type === 'MACHINE')"
                :selected="selectedMachines"
                :dataValidation="'step_resource_machine'"
                @input="items => selectResource(items, 'machines')"
                :placeholder="editMode ? 'Select Machines' : 'Machines'"
              />
          </div>
          <div class="input-group mt-1" :class="{ 'dropdown-disabled': !editMode }" data-validation="step_resource_tool" v-if="!outSourceToggle && processPlanFeature && !editData.qcParentStepId">
            <label class="key v-center ">{{ editMode ? 'Select Tools' : 'Tools' }}<span class="required-asterisk">*</span></label>
            <MultiSelectDropdown
              :options="resourceList.filter(r => r.type === 'TOOL')"
              :selected="selectedTools"
              :dataValidation="'step_resource_tool'"
              @input="items => selectResource(items, 'tools')"
              :placeholder="editMode ? 'Select Tools' : 'Tools'"
            />
          </div>
            <div class="v-center gap-1 input-group mt-2" v-if="processPlanFeature && !editData.qcParentStepId" >
            <label class="sourceSelect">Quality check:</label>
            <check-box :disabled="!editMode" :checked="editData.qualityCheck" @change="(value)=>{editData.qualityCheck = value}"/>
            </div>
  <!--  workflow  outsource/insource end  -->

        <!-- adding more next step  -->
        <div class="gap-1"  v-if="showTriggerActions" >
          <hr class="my-4" />
          <div class="mt-1" :class="{ 'dropdown-disabled': !editMode }">
            <h3 class="v-center mb-2  trigger-action-heading">
              Trigger Action
              <img
                class="pointer ml-2"
                src="@/assets/images/icons/info-icon.svg"
                width="15"
                height="15"
                alt="info icon"
                v-tooltip="
                  'An action will trigger once the workflow completes.'
                "
              />
            </h3>
            <div data-validation="step_trigger_action" class="input-group">
              <label>{{ editMode ? 'Select Action Type' : 'Action Type' }}</label>
            <custom-dropdown
              :list="triggerTypes"
              :selected="currentTriggerSelection"
              @select="handleActionType"
              class="form-template-container-wft"
            />
            </div>
            <div class="my-2 input-group" v-if="selectedActionType['1'] && isLastStep">
              <label>{{ editMode ? 'Select Form Template' : 'Form Template' }}</label>
              <div class="flex v-center gap-1">
                <custom-dropdown
                  :list="formTempaltesFiltered"
                  :selected="editData.formTemplate"
                  @select="hadleTemplateSelect"
                  @toggle="formSearchKeyword = ''"
                  @deselect="(tempalate) => {}"
                  class="form-template-container-wft flex-grow"
                >
                  <template #before-items>
                    <div
                      class="fh input-group center p-3 form-template-container-wft-search-box"
                    >
                      <input
                        type="text p-2"
                        class="form-template-container-wft-input"
                        v-model="formSearchKeyword"
                        placeholder="Search"
                      />
                    </div>
                    <div
                      class="fh center py-4"
                      v-if="formTempaltesFiltered.length === 0"
                    >
                      No forms templates
                    </div>
                  </template>
                </custom-dropdown>
                <img
                  v-if="editMode"
                  src="~@/assets/images/delete-icon.svg"
                  width="18"
                  alt="delete icon"
                  class="pointer"
                  @click="removeAction(1)"
                />
              </div>
            </div>

            <div v-if="selectedActionType['2']" class="mt-3 input-group">
              <label>File upload</label>
              <div class="v-center space-between mt-1">
                <!-- doc upload start or end consent   -- start -->
                <!-- as per Ravi's  request disbaled selection (default value will bw on start ) -->
                <div class="v-center gap-1 grow-1 pnt-disabled">
                <span>On: </span>
                <div class="toggle-btn">
                  <button
                    :class="[
                      'toggle-option',
                      { active: docUploadTime === 'on_start' },
                    ]"
                    @click="toggleButton('on_start')"
                  >
                    Start
                  </button>
                  <button
                    :class="[
                      'toggle-option',
                      { active: docUploadTime === 'on_end' },
                    ]"
                    @click="toggleButton('on_end')"
                  >
                    End
                  </button>
                </div>
                </div>
                <!-- doc upload start or end consent   -- end -->
                <div class="v-center gap-1 grow-1">
                <div>Mandatory: </div>
                <input type="checkbox" v-model="editData.uploadMandatory" :disabled="!editMode"/>
              </div>
                  <img
                  v-if="editMode"
                  src="~@/assets/images/delete-icon.svg"
                  width="18"
                  alt="delete icon"
                  class="pointer"
                  @click="removeAction(2)"
                />
              </div>

            </div>
            <div v-if="selectedActionType['3']" class="change-action-grid gap-1 mt-3">
              <div class="input-group imp" data-validation="step_target_field">
                <label>Target field</label>
                <custom-dropdown
                  :list="changeTargetFields"
                  :selected="changeTargetFieldSelected"
                  @select="handleTargetFieldSelect"
                  @deselect="clearChangeField('target_field')"
                  class="form-template-container-wft"
                />
              </div>
              <div class="input-group imp" data-validation="step_target_value_int">
                <label>Target value</label>
                <custom-dropdown
                  :list="changeTargetValues"
                  :key="`target-value-${editData.target_field || 'none'}-${editData.target_value_int || 'none'}`"
                  :selected="changeTargetValueSelected"
                  @select="handleTargetValueSelect"
                  @deselect="clearChangeField('target_value_int')"
                  class="form-template-container-wft"
                />
              </div>
              <div class="input-group change-action-delete-wrap">
                <label>&nbsp;</label>
                <div class="change-action-delete-row">
                  <img
                    v-if="editMode"
                    src="~@/assets/images/delete-icon.svg"
                    width="18"
                    alt="delete icon"
                    class="pointer"
                    @click="removeAction(3)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--  edit node end  -->
      <!-- edit phase start -->
      <div class="input-group imp mt-1" v-else-if="shape === 'phase-rect'" data-validation="step_name">
        <label class="key">{{ editMode ? 'Enter the phase name:' : 'Phase name:' }}</label>
        <input
          type="text"

          v-model="editData.newLabel"
          :placeholder="editMode ? 'Enter new name' : ''"
          maxlength="30"
          :disabled="!editMode"
        />
      </div>
      <!-- edit phase end -->
      <!-- edit node start -->
      <div class="input-group imp" v-else-if="shape === 'edge'" data-validation="step_name">
        <label class="key">{{ editMode ? 'Enter the edge name:' : 'Edge name:' }}</label>
        <input
          type="text"
          v-model="editData.newLabel"
          :placeholder="editMode ? 'Enter new name' : ''"
          maxlength="30"
          :disabled="!editMode"
        />

        <!-- transition doc selector  start -->
        <!-- <div class="my-2 input-group" v-if="shape === 'edge'">
          <hr class="my-2" />
          <h4>Trigger Actions</h4>
          <div class="grid-3 gap-1 mt-2">
            <custom-dropdown
              :list="[{ id: 1, name: 'Document' }]"
              :selected="selectedActionType"
              @select="handleActionType"
              @deselect="selectedActionType = {}"
              class="form-template-container-wft"
            />
            <custom-dropdown
              :list="[]"
              :selected="selectedActionType"
              @select="handleActionType"
              @deselect="selectedActionType = { id: -1, name: 'Select' }"
              class="form-template-container-wft"
            />
            <custom-dropdown
              :list="[]"
              :selected="selectedActionType"
              @select="handleActionType"
              @deselect="selectedActionType = { id: -1, name: 'Select' }"
              class="form-template-container-wft"
            />
          </div>
        </div> -->
        <!-- transition doc selector  end -->
      </div>
    </div>
    <div class="gap-1 flex-end save-btn-grp" v-if="editMode">
      <button class="btn btn-cancel" @click="$emit('cancel')">Cancel</button>
      <button class="btn" @click="saveData">Save</button>
    </div>
  </div>
</template>
<script>
import customDropdown from '@/components/common/customDropdown.vue'
import checkBox from '@/components/common/checkbox.vue'
import config from '@/config'
import { getFormTemplates, getResources } from '@/api'
import errorBorder, { removeErrorBorder } from '@/helper/formValidation/errorBorder'
import MultiSelectDropdown from '../common/customMultiSelect.vue'
import { emptyString } from '@/helper/formValidation'
export default {
  name: 'editWfModalComponent',
  components: { customDropdown, checkBox, MultiSelectDropdown },
  props: {
    shape: {
      type: String,
      default: 'node-rect'
    },
    data: {
      type: Object,
      default: () => ({})
    },
    userGroups: {
      type: Array,
      default: () => []
    },
    allFormsTemplate: {
      type: Array,
      default: () => []
    },
    isLastStep: {
      type: Boolean,
      default: false
    },
    selectedSubCateId: {
      type: Number,
      default: null
    },
    selectedFeatureId: {
      type: Number,
      default: null
    },
    editMode: {
      type: Boolean,
      default: false
    },
    isFirstStep: {
      type: Boolean,
      default: false
    }

  },
  data: () => ({
    editData: { userGroup: null, outSource: false, resourceGroup: [] },
    triggerTypes: [],
    selectedActionType: {},
    formSearchKeyword: '',
    docUploadTime: null, // default value for document upload time,
    window: window,
    config: config,
    outSourceToggle: false,
    resourceList: [],
    qcFormTempaltes: [],
    selectedTools: [],
    selectedMachines: []
  }),
  computed: {
    formTempaltesFiltered () {
      if (this.formSearchKeyword === '') {
        return this.allFormsTemplate
      }
      const forms = this.allFormsTemplate.filter((item) =>
        item.name.toLowerCase().includes(this.formSearchKeyword.toLowerCase())
      )
      return forms
    },
    qcFormTempaltesFiltered () {
      if (this.formSearchKeyword === '') {
        return this.qcFormTempaltes
      }
      const forms = this.qcFormTempaltes.filter((item) =>
        item.name.toLowerCase().includes(this.formSearchKeyword.toLowerCase())
      )
      return forms
    },
    showremoveUserGroup () {
      return this.editData.userGroup && this.editData.userGroup !== null && this.editData.userGroup !== undefined
    },
    processPlanFeature () {
      return this.config.CORE_FEATURES.MATERIAL === this.selectedFeatureId && this.selectedSubCateId === config.WORKFLOW_SUB_CATE.PROCESS_PLAN
    },
    showTriggerActions () {
      return this.shape === 'node-rect' || (this.shape === 'qc-rect' && this.isLastStep)
    },
    isLifecycleCategory () {
      if (!this.selectedSubCateId) return false
      return config.WORKFLOW_SUB_CATE.LIFECYCLE === this.selectedSubCateId
    },
    currentTriggerSelection () {
      return this.selectedActionType[1] || this.selectedActionType[2] || this.selectedActionType[3] || {}
    },
    changeTargetFields () {
      if (this.selectedFeatureId === this.config.CORE_FEATURES.MATERIAL) {
        return [{ id: 'status', name: 'Status' }]
      }
      if (
        this.selectedFeatureId === this.config.CORE_FEATURES.BOM ||
        this.selectedFeatureId === this.config.CORE_FEATURES.DOCUMENTS
      ) {
        return [{ id: 'state', name: 'State' }]
      }
      return []
    },
    changeTargetValues () {
      const isCheckoutValue = (value) => {
        return String(value || '').trim().toLowerCase() === 'checkout'
      }
      if (this.selectedFeatureId === this.config.CORE_FEATURES.MATERIAL) {
        return Object.keys(this.config.MATERIAL_STATUS_MAP).map((key) => ({
          id: Number(key),
          name: this.config.MATERIAL_STATUS_MAP[key]
        })).filter(item => !isCheckoutValue(item.name))
      }
      if (this.selectedFeatureId === this.config.CORE_FEATURES.DOCUMENTS) {
        return Object.keys(this.config.DOC_STATE).map((key) => ({
          id: Number(key),
          name: this.config.DOC_STATE[key]
        })).filter(item => !isCheckoutValue(item.name))
      }
      if (this.selectedFeatureId === this.config.CORE_FEATURES.BOM) {
        return Object.keys(this.config.BOM_STATE_MAP).map((key) => ({
          id: this.config.BOM_STATE_MAP[key],
          name: key
        })).filter(item => !isCheckoutValue(item.name))
      }
      return []
    },
    changeTargetFieldSelected () {
      if (!this.editData.target_field) return {}
      const targetField = String(this.editData.target_field).toLowerCase()
      return this.changeTargetFields.find(item => item.id === targetField) || {}
    },
    changeTargetValueSelected () {
      if (!this.editData.target_value_int) return {}
      const targetValue = Number(this.editData.target_value_int)
      return this.changeTargetValues.find(item => Number(item.id) === targetValue) || {}
    }
  },
  mounted () {
    this.editData = this.data
    if (this.editData.target_field) {
      this.editData.target_field = String(this.editData.target_field).toLowerCase()
    }
    if (this.editData.target_value_int !== null && this.editData.target_value_int !== undefined && this.editData.target_value_int !== '') {
      this.editData.target_value_int = Number(this.editData.target_value_int)
    }
    this.editData.durationType = this.editData.durationType || 2
    this.outSourceToggle = this.editData.outSource || false
    // this is use full when tried to edit the node
    if (this.editData.docUploadTime) {
      this.selectedActionType['2'] = { id: 2, name: 'File upload' }
      this.docUploadTime = this.editData.docUploadTime
    }
    if (this.editData.formTemplate?.id) {
      this.selectedActionType = { ...this.selectedActionType, 1: { id: 1, name: 'Form Create' } }
    }
    if (this.editData.trigger_actions === 'UPDATE' || (this.editData.target_field && this.editData.target_value_int)) {
      this.selectedActionType = { ...this.selectedActionType, 3: { id: 3, name: 'Change' } }
    }
    if (this.isLastStep) {
      this.triggerTypes = [
        { id: 1, name: 'Form Create' },
        { id: 2, name: 'File upload' }
      ]
    } else {
      this.triggerTypes = [
        { id: 2, name: 'File upload' }
      ]
    }
    if (this.isLifecycleCategory) {
      this.triggerTypes.push({ id: 3, name: 'Change' })
    }
    // this is used to remove the text selection on the modal
    if (this.window.getSelection) {
      this.window.getSelection().removeAllRanges()
    } else if (this.window.document.selection) {
      this.window.document.selection.empty() // For IE < 9
    }
    if (!this.editData.outSource) {
      this.getResourceGroups()
    }
    if (this.shape === 'qc-rect') {
      this.getAllFormTempalates()
    }
  },
  methods: {
    setOutsource (value) {
      this.outSourceToggle = value

      if (value) {
        this.selectedTools = []
        this.selectedMachines = []
        this.editData.resourceGroup = []
      }
    },
    blockMinus (e) {
      if (e.key === '-' || e.key === 'e') {
        e.preventDefault()
      }
    },
    onChangeDuration (event) {
      if (event.target.value < 0) {
        event.target.value = 0
        this.editData.escalation = 0
      }
    },
    handleActionType (type) {
      removeErrorBorder(['step_trigger_action'])
      // this.selectedActionType = { ...this.selectedActionType, [type.id]: type }
      this.selectedActionType = { [type.id]: type }
      if (type.id === 2) {
        // file upload
        this.editData.docUploadTime = this.docUploadTime = 'on_start'
        this.editData.formTemplate = {}
        this.editData.trigger_actions = 'FILE_UPLOAD'
        this.clearChangeField('target_field')
        this.clearChangeField('target_value_int')
      } else if (type.id === 1) {
        this.editData.docUploadTime = null
        this.editData.uploadMandatory = null
        this.editData.trigger_actions = 'CREATE'
        this.clearChangeField('target_field')
        this.clearChangeField('target_value_int')
      } else if (type.id === 3) {
        this.editData.docUploadTime = null
        this.editData.uploadMandatory = null
        this.editData.formTemplate = {}
        this.editData.trigger_actions = 'UPDATE'
        const defaultTargetField = this.changeTargetFields[0]
        if (defaultTargetField?.id) {
          this.editData.target_field = defaultTargetField.id
        }
      } else if (type.id === -1) {
        this.selectedActionType = {}
        this.docUploadTime = null
        this.editData.formTemplate = {}
        this.editData.uploadMandatory = null
        this.editData.trigger_actions = null
        this.clearChangeField('target_field')
        this.clearChangeField('target_value_int')
      }
    },
    handleTargetFieldSelect (field) {
      this.editData.target_field = String(field.id).toLowerCase()
      this.editData.target_value_int = null
    },
    handleTargetValueSelect (item) {
      this.editData = { ...this.editData, target_value_int: item.id }
    },
    clearChangeField (field) {
      this.editData[field] = null
      this.editData = { ...this.editData }
    },
    hadleTemplateSelect (template) {
      this.editData = { ...this.editData, formTemplate: template }
    },
    hadleQcFormTempalate (template) {
      this.editData = { ...this.editData, qcFormTempalate: template }
    },
    toggleButton (btn) {
      this.docUploadTime = btn
      if (btn === 'on_start') {
        this.editData.docUploadTime = 'on_start'
      } else {
        this.editData.docUploadTime = 'on_end'
      }
    },
    removeAction (typeId) {
      if (typeId === 1) {
        this.editData.formTemplate = {}
        this.selectedActionType[1] = null
      } else if (typeId === 2) {
        this.docUploadTime = null
        this.editData.docUploadTime = null
        this.editData.uploadMandatory = null
        this.selectedActionType[2] = null
      } else if (typeId === 3) {
        this.clearChangeField('target_field')
        this.clearChangeField('target_value_int')
        this.editData.trigger_actions = null
        this.selectedActionType[3] = null
      }
    },
    userGroupchange (data) {
      this.editData = { ...this.editData, userGroup: data.id }
    },
    saveData () {
      this.editData.outSource = this.outSourceToggle
      if (!this.validateEntries()) {
        return
      }
      this.$emit('save', this.editData)
    },
    validateEntries () {
      let flag = true
      if (this.shape === 'node-rect' || this.shape === 'qc-rect') {
        if (!this.editData.newLabel || this.editData.newLabel === 'Title') { errorBorder('step_name', true); flag = false } else errorBorder('step_name', false)
        if (!this.editData.userGroup) {
          errorBorder('step_department', true); flag = false
        } else errorBorder('step_department', false)
        if (!/^\d+(\.\d+)?$/.test(this.editData.duration)) { errorBorder('step_duration', true); flag = false } else errorBorder('step_duration', false)
        if (this.editData.escalation && !/^\d+(\.\d+)?$/.test(this.editData.escalation)) { errorBorder('step_escaltion', true); flag = false } else errorBorder('step_escaltion', false)
        if (!this.editData.durationType) { errorBorder('step_duration', true); flag = false } else errorBorder('step_duration', false)
        if (!this.editData.duration) { errorBorder('step_duration', true); flag = false } else errorBorder('step_duration', false)
        if (this.processPlanFeature && this.shape !== 'qc-rect') {
          if (!this.outSourceToggle && !this.selectedMachines.length) {
            errorBorder('step_resource_machine', true); flag = false
          } else errorBorder('step_resource_machine', false)
          if (!this.outSourceToggle && !this.selectedTools.length) {
            errorBorder('step_resource_tool', true); flag = false
          } else errorBorder('step_resource_tool', false)
        }
        if (this.shape === 'qc-rect') {
          if (!this.editData.qcFormTempalate) { errorBorder('step_checklist_template', true); flag = false } else errorBorder('step_checklist_template', false)
        }
        if (this.selectedActionType['3']) {
          if (!this.editData.target_field) { errorBorder('step_target_field', true); flag = false } else errorBorder('step_target_field', false)
          if (!this.editData.target_value_int) { errorBorder('step_target_value_int', true); flag = false } else errorBorder('step_target_value_int', false)
        } else {
          errorBorder('step_target_field', false)
          errorBorder('step_target_value_int', false)
        }
        if (this.isLastStep && this.isLifecycleCategory && !this.editData.target_value_int) {
          flag = false
          emptyString('', 'Action', 'step_trigger_action', false, true, 'Change action requires for last step of lifecycle workflow')
        }
      } else if (this.shape === 'phase-rect') {
        if (!this.editData.newLabel || this.editData.newLabel === 'Phase') { errorBorder('step_name', true); flag = false } else errorBorder('step_name', false)
      } else if (this.shape === 'edge') {
        if (!this.editData.newLabel || this.editData.newLabel === 'transition') {
          flag = false
          errorBorder('step_name', true)
        } else errorBorder('step_name', false)
      }
      return flag
    },
    getResourceGroups () {
      if (this.resourceList.length > 0 && !this.outSource) {
        return
      }
      getResources({
      }).then((res) => {
        const list = res.core_material_master || []
        list.forEach(item => {
          const obj = {
            name: item.material_name,
            id: item.id,
            type: item.resource_type_value?.name
          }
          this.resourceList.push(obj)
        })
      })
    },
    getAllFormTempalates () {
      getFormTemplates(false, config.QUALITY_CHECKLIST_FORM.form_type)
        .then((res) => {
          this.qcFormTempaltes = res.core_form_templates
            .map((item) => {
              return {
                workflow_id: item.workflow_template_id,
                id: item.id,
                name: item.name
              }
            })
        })
        .catch((err) => {
          console.log(err)
        })
    },
    selectResource (items, type) {
      if (type === 'tools') {
        const removed = this.selectedTools.filter(id => !items.includes(id))
        this.selectedTools = items
        this.selectedMachines = this.selectedMachines.filter(
          id => !removed.includes(id)
        )
      }
      if (type === 'machines') {
        const removed = this.selectedMachines.filter(id => !items.includes(id))
        this.selectedMachines = items
        this.selectedTools = this.selectedTools.filter(
          id => !removed.includes(id)
        )
      }

      this.editData.resourceGroup = [
        ...new Set([...this.selectedTools, ...this.selectedMachines])
      ]
      this.editData = { ...this.editData }
    },
    refershEditData (clearField) {
      if (clearField) {
        this.editData[clearField] = null
      }
      this.editData = { ...this.editData }
    }
  },
  watch: {
    outSourceToggle (newVal) {
      this.getResourceGroups()
    },
    resourceList (list) {
      if (!list?.length || !this.editData.resourceGroup?.length) return

      this.selectedMachines = list.filter(
        item =>
          item.type === 'MACHINE' &&
      this.editData.resourceGroup.includes(item.id)
      ).map(r => r.id)

      this.selectedTools = list.filter(
        item =>
          item.type === 'TOOL' &&
      this.editData.resourceGroup.includes(item.id)
      ).map(r => r.id)
    }
  }
}

</script>
<style lang="scss" scoped>
.required-asterisk {
  color: var(--brand-color-1);
  font-size: 1.2em;
  margin-left: 0.1em;
}
.toggle-btn {
  height: 1.3em;
  display: inline-flex;
  border: 1px solid #ccc;
  border-radius: 6px;
  background-color: #e0e0e0;
  //padding: 1px; //not necessary
  align-items: center;
  overflow: hidden;
}

.toggle-option {
  flex: 1;
  padding: 8px 16px;
  border: none;
  background-color: #e0e0e0;
  cursor: pointer;
  font-size: var(--text-base);
  font-weight: 400;
  // transition: all 0.1s ease-in-out;
}

.toggle-option.active {
  background-color: white;
  color: black;
  font-weight: 600;
  border: 1px solid #bbb;
  // box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2), 0 2px 4px rgba(0, 0, 0, 0.15),
  //   inset 0 0 6px rgba(0, 0, 0, 0.2);
  // text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  transition: all 0.15s ease-in-out;
  border-radius: 6px;
  // background-color: var(--brand-light-color);
  // color: black;
  // font-weight: 600;
  // border: 1px solid var(--brand-dark-color);
  // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
.sourceSelect{
  width:fit-content;
}
.modalcontainer{
  overflow-y: auto;
  margin-bottom: 20px;
}
.condition-builder-entry {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
}
.condition-settings-btn {
  border: 1px solid #d1d5db;
  border-radius: 6px;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.condition-settings-btn:hover {
  background: #f3f4f6;
}
.save-btn-grp{
    position: absolute;
    bottom: 0;
    /* top: 0px; */
    width: -webkit-fill-available;
    padding: 12px 24px;
    margin-bottom: px;
    border-radius: 8px;
}
.dropdown-disabled {
  pointer-events: none;
  opacity: 0.6;
  cursor: not-allowed;
}
.change-action-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;
  width: 100%;
}
.change-action-grid :deep(.form-template-container-wft) {
  width: 100%;
}
.change-action-delete-wrap {
  display: flex;
  flex-direction: column;
}
.change-action-delete-row {
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.trigger-action-heading{
  font-size: var(--text-lg);
  font-weight: 400;
}
.view-mode input,
.view-mode select,
.view-mode textarea {
  background-color: #f8fafc;
  border-color: #e5e7eb;
  color: var(--text-color, #111827);
  opacity: 1;
}
.view-mode .toggle-btn {
  background-color: #f3f4f6;
}
.view-mode .toggle-option,
.view-mode .condition-settings-btn,
.view-mode .pointer {
  cursor: default;
}
.view-mode .condition-settings-btn {
  opacity: 0.6;
}
.view-mode :deep(.form-template-container-wft) {
  background-color: #f8fafc;
  border-color: #e5e7eb;
}
.view-mode :deep(.dropdown-icon) {
  display: none;
}
.view-mode .dropdown-disabled {
  opacity: 1;
}
</style>
